import { render } from "./home-sec2.vue?vue&type=template&id=24b73983"
import script from "./home-sec2.vue?vue&type=script&lang=js"
export * from "./home-sec2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__